<template>
    <CommonDialog :value="value" :title="$t('ChangePassword')" width="500" :fullscreen="false" show-action-toolbar @input="$emit('input', false)">

        <v-form ref="form" v-model="valid" lazy-validation @submit.prevent="save" :disabled="loading">
            <v-container>
                <v-row>
                    <v-col cols="12" class="pb-0">
                        <v-text-field type="password"
                                      v-model="oldPassword"
                                      :rules="[rules.required]"
                                      autocomplete="off"
                                      :label="$t('CurrentPassword')"></v-text-field>
                    </v-col>
                    <v-col cols="12" class="pb-0 pt-0">
                        <v-text-field :type="show ? 'text' : 'password'"
                                      v-model="password1"
                                      :append-icon="show ? 'mdi-eye' : 'mdi-eye-off'"
                                      @click:append="show = !show"
                                      :rules="[rules.required, rules.min8, rules.nospaces, rules.complex, rules.nomatch1]"
                                      autocomplete="off"
                                      :label="$t('NewPassword')"></v-text-field>
                    </v-col>
                    <v-col cols="12" class="pt-0">
                        <v-text-field :type="show ? 'text' : 'password'"
                                      v-model="password2"
                                      :rules="[rules.required, rules.nomatch2, rules.min8, rules.nospaces, rules.complex]"
                                      autocomplete="off"
                                      :label="$t('ReNewPassword')"></v-text-field>
                    </v-col>
                    <v-col cols="12" class="pt-0" v-if="showCodeInput">
                        <span class="subtitle-1">{{ $t('code-sent-tomobile') }}</span>
                    </v-col>
                    <v-col cols="12" class="pt-0" v-if="showCodeInput">
                        <v-otp-input length="4" v-model="code"></v-otp-input>
                    </v-col>
                </v-row>
            </v-container>
            <v-divider></v-divider>
            <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary" class="white--text" tile :disabled="loading" type="submit">{{ $t("Update") }}</v-btn>
                <v-btn color="error" @click="close()" tile :disabled="loading">{{ $t("Cancel") }}</v-btn>
            </v-card-actions>
        </v-form>

    </CommonDialog>
</template>
<script>


    import CommonDialog from '@/components/controls/CommonDialog.vue'
    import UsersService from '@/services/UsersService'

    export default {

        components: {
            CommonDialog
        },

        props: {
            value: {
                type: Boolean,
                default: null
            },
        },

        data() {
            return {
                password1: null,
                password2: null,
                oldPassword: null,
                code: null,
                showCodeInput: false,
                validator: null,
                show: false,
                loading: false,
                valid: false,
                rules: {
                    required: (v) => !!v || this.$t('Required'),
                    min8: (v) => v && v.length >= 8 || this.$t('Atleast8Characters'),
                    nospaces: (v) => v && v.match(/^\S*$/g) != null || this.$t('spaces-not-allowed'),
                    complex: (v) => v && v.match(/(?=.*[A-Z])(?=.*[a-z])(?=.*[0-9])(?=.*[~!@#$%^*\-\_=+[{\]};:,.?])/g) != null || this.$t('ComplexPassword'),
                    nomatch1: (v) => !this.password2 || v == this.password2 || this.$t('PasswordsDontMatch'),
                    nomatch2: (v) => !this.password1 || v == this.password1 || this.$t('PasswordsDontMatch'),
                }
            }
        },

        methods: {
            close() {
                this.$emit('input', false)
            },

            save() {
                if (this.$refs.form.validate()) {
                    this.loading = true

                    UsersService.updatePassword({
                        oldPassword: this.oldPassword,
                        newPassword: this.password2,
                        code: this.code,
                        validator: this.validator
                    }).then((res) => {
                        if (res.data) {
                            //if data is empty then change password without sms verification
                            this.close()
                        } else {
                            this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                        }
                    }).catch(() => {
                        this.$root.$notification(this.$t('ErrorOccurred'), 'error')
                    }).finally(() => {
                        this.loading = false
                    })
                }
            },
        }
    }
</script>